/**
 * Utilitários para WebSocket - Centraliza a lógica de seleção de corretora
 */

import { subscribeSymbol as subscribeSymbolBinance, unSubscribeSymbol as unSubscribeSymbolBinance } from '@/services/binance/spot/binance'
import { subscribeSymbol as subscribeSymbolMexc, unSubscribeSymbol as unSubscribeSymbolMexc } from '@/services/mexc/spot/mexc'

/**
 * Inscreve em um símbolo baseado na corretora selecionada
 * @param {string} symbol - Símbolo para inscrever (ex: 'BTCUSDT')
 * @param {string} exchange - Corretora ('binance' ou 'mexc')
 */
export const subscribeSymbol = (symbol, exchange = 'binance') => {
  if (exchange === 'binance') {
    return subscribeSymbolBinance(symbol)
  }
  if (exchange === 'mexc') {
    return subscribeSymbolMexc(symbol)
  }
  // Exchange not supported, using Binance as default
  return subscribeSymbolBinance(symbol)
}

/**
 * Desinscreve de um símbolo baseado na corretora selecionada
 * @param {string} symbol - Símbolo para desinscrever (ex: 'BTCUSDT')
 * @param {string} exchange - Corretora ('binance' ou 'mexc')
 */
export const unSubscribeSymbol = (symbol, exchange = 'binance') => {
  if (exchange === 'binance') {
    return unSubscribeSymbolBinance(symbol)
  }
  if (exchange === 'mexc') {
    return unSubscribeSymbolMexc(symbol)
  }
  // Exchange not supported, using Binance as default
  return unSubscribeSymbolBinance(symbol)
}

/**
 * Obtém os dados de ticker baseado na corretora
 * @param {string} symbol - Símbolo (ex: 'BTCUSDT')
 * @param {string} exchange - Corretora ('binance' ou 'mexc')
 * @param {object} store - Store Vuex
 */
export const getTicker = (symbol, exchange = 'binance', store) => {
  if (exchange === 'binance') {
    return store.state.binanceSpot.tickers[symbol]
  }
  if (exchange === 'mexc') {
    return store.state.mexcSpot.tickers[symbol]
  }
  // Exchange not supported, using Binance as default
  return store.state.binanceSpot.tickers[symbol]
}

/**
 * Lista de exchanges suportadas
 */
export const SUPPORTED_EXCHANGES = ['binance', 'mexc']

/**
 * Verifica se uma exchange é suportada
 * @param {string} exchange - Nome da exchange
 */
export const isExchangeSupported = exchange => SUPPORTED_EXCHANGES.includes(exchange)
